import { render, staticRenderFns } from "./SubItemContent.vue?vue&type=template&id=1244cb6c&scoped=true"
import script from "./SubItemContent.vue?vue&type=script&lang=ts"
export * from "./SubItemContent.vue?vue&type=script&lang=ts"
import style0 from "./SubItemContent.vue?vue&type=style&index=0&id=1244cb6c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1244cb6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1244cb6c')) {
      api.createRecord('1244cb6c', component.options)
    } else {
      api.reload('1244cb6c', component.options)
    }
    module.hot.accept("./SubItemContent.vue?vue&type=template&id=1244cb6c&scoped=true", function () {
      api.rerender('1244cb6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/main-drawer/main-drawer-item/SubItemContent.vue"
export default component.exports